import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef
} from '@angular/core';
import { Hosted } from 'protractor/built/driverProviders';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  @Input() closable:Boolean;
  @Input() show:Boolean;
  @Output() closed = new EventEmitter<Boolean>();

  private _checked = false;

  constructor(private hostElement: ElementRef){
  }

  ngDoCheck(){
    if (this.show && !this._checked){
      var body = document.getElementsByTagName('body')[0];
      body.appendChild(this.hostElement.nativeElement);
      var top = body.scrollTop;
      body.classList.add('noScroll');
      body.style.top = (-top) + 'px';
      this._checked = true;
    } else if (!this.show && this._checked) {
      var body = document.getElementsByTagName('body')[0];
      var scrollTop = body.style.top.split('px')[0];
      document.getElementsByTagName('body')[0].classList.remove('noScroll');
      body.scrollTop = -1 * parseInt(scrollTop);
      this._checked = false;
    }
  }

  ngOnInit(){
  }

  close($e){
    this.show = false;
    this.closed.next(true);
  }
}
